"use strict";

const version = "3.4.17";
module.exports = version;
